import axios from 'axios';
import { tl } from './inlineI18n';
import { playGemInsertSound, playEnhanceFailSound, playCraftSuccessSound } from './buttonClickSound';

// Taş takma / Taş Temizleme Kiti sürükle-bırak işlemleri (envanter, demirci, giyili eşya ortak).
export const isSocketDropBlocked = (drop) => !!drop && (drop.noSocket || drop.full || drop.empty);

export const socketDropBlockedMessage = (drop) => {
  if (drop.noSocket) return tl('Bu eşyada soket yok.', 'This item has no sockets.');
  if (drop.empty) return tl('Bu eşyada temizlenecek taş yok.', 'No stones to clear on this item.');
  return tl('Bu eşyada boş soket yok.', 'No empty socket on this item.');
};

export const performSocketDrop = async (drop, { setError, setStatus } = {}) => {
  if (isSocketDropBlocked(drop)) {
    setError?.(socketDropBlockedMessage(drop));
    return false;
  }
  try {
    if (drop.type === 'socketClear') {
      const res = await axios.post('/api/sockets/clear', {
        itemType: drop.itemType,
        userItemId: drop.userItemId,
        otherId: drop.otherId,
      });
      if (res.data?.success) {
        playCraftSuccessSound();
        setStatus?.(res.data.message);
        return true;
      }
      setError?.(res.data?.message || tl('Temizlenemedi.', 'Could not clear.'));
      return false;
    }
    const res = await axios.post('/api/sockets/insert', {
      itemType: drop.itemType,
      userItemId: drop.userItemId,
      socketIndex: -1,
      otherId: drop.otherId,
    });
    if (res.data?.success && res.data.inserted) {
      playGemInsertSound();
      setStatus?.(res.data.message);
      return true;
    }
    playEnhanceFailSound(0.6);
    setError?.(res.data?.message || tl('Taş takılamadı.', 'Could not insert stone.'));
    return false;
  } catch (err) {
    setError?.(err.response?.data?.message || err.message);
    return false;
  }
};
